/* unplugin-vue-components disabled */import script from "./RoleGeneratorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleGeneratorPage.vue?vue&type=script&setup=true&lang=js"

import "./RoleGeneratorPage.vue?vue&type=style&index=0&id=123668da&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123668da"]])

export default __exports__